import moment from 'moment'
import { adminValidationSource } from './validation-source'
import { adminRouteContext } from './route-context'

// Explicit opt-in preserves customer-facing components and their locale rules.
export default {
  inject: { inheritedAdminLocalization: { from: 'adminLocalization', default: false } },
  props: { adminContext: { type: Boolean, default: false } },
  computed: {
    isAdminLocalization() {
      if (this.$adminLocalizationEnabled && !this.$adminLocalizationEnabled()) return false
      // A reused component must follow the active route, including navigation
      // from an authenticated organizer screen to a public registration page.
      const routeContext = adminRouteContext(this.$route)
      if (routeContext === false) return false
      if (this.adminContext || routeContext === true) return true

      return this.inheritedAdminLocalization
    },
  },
  methods: {
    adminText(key, source, params) {
      if (this.isAdminLocalization) return this.$adminT(key, source, params)

      return source.replace(/{{\s*([^{}]+?)\s*}}/g, (token, name) =>
        params && Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : token)
    },
    adminFieldValidationMessages(original) {
      const source = adminValidationSource(original)
      if (!this.isAdminLocalization || !source) return original
      const defaults = this.adminValidationMessages(original)
      const displayed = { ...original }
      Object.keys(original).forEach(key => { if (defaults[key]) displayed[key] = defaults[key] })
      if (source.requiredSwitch) displayed.sameAs = defaults.required
      const boundary = value => moment(value).locale(this.$adminLocale()).format(this.$adminLocale() === 'hr' ? 'DD.MM.YYYY.' : 'YYYY-MM-DD')
      if (source.minDate) displayed.minDate = this.adminText('workflowsAll.schema_min_date', 'Date must be on or after {{date}}', { date: boundary(source.minDate) })
      if (source.maxDate) displayed.maxDate = this.adminText('workflowsAll.schema_max_date', 'Date must be on or before {{date}}', { date: boundary(source.maxDate) })

      return displayed
    },
    adminValidationMessages(original) {
      if (!this.isAdminLocalization) return original

      return {
        required: this.adminText('shared.validation.required', 'This field is required'),
        date: this.adminText('shared.validation.date', 'This field must be date'),
        between: this.adminText('shared.validation.between', 'This field is out of range'),
        minLength: this.adminText('shared.validation.minLength', 'This field should contain more values'),
        maxLength: this.adminText('shared.validation.maxLength', 'This field should contain less values'),
        minDate: this.adminText('shared.validation.minDate', 'This field should be after'),
        maxDate: this.adminText('shared.validation.maxDate', 'This field should be before'),
        email: this.adminText('shared.validation.email', 'This field must be an email'),
        httpUrl: this.adminText('shared.validation.httpUrl', 'This field must be http or https url'),
        minValue: this.adminText('shared.validation.minValue', 'Provided value is too small'),
        maxValue: this.adminText('shared.validation.maxValue', 'Provided value is too big'),
        sameAs: this.adminText('shared.validation.sameAs', 'This field must be the same as some other field'),
        notIn: this.adminText('shared.validation.notIn', 'Provided value is already taken'),
        numeric: this.adminText('shared.validation.numeric', 'This field must be a number'),
        url: this.adminText('shared.validation.url', 'This field must a valid url'),
        uniqueTicketCategoryPriority: this.adminText('shared.validation.uniqueTicketCategoryPriority', 'Category priority is already in use'),
        sameAsEmail: this.adminText('shared.validation.sameAsEmail', 'Email addresses do not match. Please ensure both email fields are identical'),
        minValueDynamic: this.adminText('shared.validation.minValueDynamic', 'Value cannot be less than minimum required'),
        minValueDynamicAdditionalCapacity: this.adminText('shared.validation.minValueDynamicAdditionalCapacity', 'Value cannot be less than minimum required'),
      }
    },
  },
}
